// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BXfF","left":"styles_left__TXx-r"};